import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["dialogTitle", "body", "footer", "className", "colorSet", "theme"];
import React, { useState } from 'react';
import { renamedPropWarning } from "../../deprecationWarnings";
import { addColorSet } from "../../styles";
import { Body } from "./Body";
import { Dialog } from "./Dialog";
import { Footer } from "./Footer";
import { Title } from "./Title";
export var DialogAlert = /*#__PURE__*/React.forwardRef(function DialogAlert(_ref, ref) {
  var dialogTitle = _ref.dialogTitle,
      body = _ref.body,
      footer = _ref.footer,
      className = _ref.className,
      _ref$colorSet = _ref.colorSet,
      colorSet = _ref$colorSet === void 0 ? 'base' : _ref$colorSet,
      theme = _ref.theme,
      props = _objectWithoutProperties(_ref, _excluded);

  if (theme) {
    renamedPropWarning('theme', 'colorSet');
  }

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      hasBorder = _useState2[0],
      setHasBorder = _useState2[1];

  return /*#__PURE__*/React.createElement(Dialog, Object.assign({
    ref: ref,
    colorSet: colorSet,
    className: addColorSet(colorSet, className)
  }, props), /*#__PURE__*/React.createElement("header", null, /*#__PURE__*/React.createElement(Title, {
    hasBorder: hasBorder,
    colorSet: colorSet
  }, dialogTitle)), /*#__PURE__*/React.createElement(Body, {
    onScroll: function onScroll(e) {
      return setHasBorder(e.target instanceof HTMLElement && e.target.scrollTop !== 0);
    }
  }, body), /*#__PURE__*/React.createElement(Footer, null, footer));
});
/**
* **DialogAlert** ![Status: Production](https://img.shields.io/badge/PRODUCTION-%2357B560|height=14)
*
* [GitHub](https://ghe.spotify.net/encore/web/tree/master/src/core/components/DialogAlert) | [Storybook](https://encore-web.spotify.net/?path=/docs/components-dialog-dialogalert--default) | [Encore](https://encore.spotify.net/web/components/dialog?format=figma-figma#dialogalert) | [Figma](https://www.figma.com/file/bnQXqGkLeiTlbk8JXGDcsX/Encore-Web---Light-Theme-Toolkit?node-id=0:1353) |
*
* DialogAlert will display a warning or verify that a user wants to continue and uses tertiary buttons.
*
* @example
* () => (
*  <DialogAlert
*    aria-label="Title"
*    aria-describedby="dialogBody"
*    dialogTitle="Title"
*    body={
*      <Type id="dialogBody" as="p">
*        Aenean lacinia bibendum nulla sed consectetur. Cras justo odio, dapibus ac facilisis in,
*        egestas eget quam. Duis mollis, est non commodo luctus.
*      </Type>
*    }
*    footer={
*      <div>
*        <ButtonTertiary buttonSize={ButtonTertiary.sm} condensed>
*          Button
*        </ButtonTertiary>
*        <ButtonTertiary buttonSize={ButtonTertiary.sm} semanticColor="textBrightAccent" condensed>
*          Button
*        </ButtonTertiary>
*      </div>
*    }
*  />
*);
*
*/

export default DialogAlert;